// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___rFUZ","type":"styles_type__2bf6L","choices":"styles_choices__28S3I"};